module.exports = __webpack_public_path__ + "6c29be92fc6a0f1e3747cfbedd249cc4.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-panel-320.webp.png
// module id = 377
// module chunks = 0